/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { useColorScheme } from '../UNSAFE_useColorScheme';
import { useScale } from '../UNSAFE_useScale';
import { themeInterpolations } from '../../utils/UNSAFE_interpolations/theme';
import type { ThemeProps } from '../../utils/UNSAFE_interpolations/theme';
import { mergeInterpolations } from '../../utils/UNSAFE_mergeInterpolations';
import { DefaultEnvironment } from '../../UNSAFE_Environment/EnvironmentContext';

// This hook encasulates the logic required to determine which theme style classes are needed
// for the current environment context's colorScheme and scale value.  This would be used when
// rendering dom outside of the current dom tree, but desire to match the colorScheme and scale
// of the original dom tree.
export function useThemeInterpolations() {
  const colorScheme = useColorScheme();
  const currentScale = useScale();
  // We don't want to interpolate the default environment values for scacle.  Those should get picked up by default.
  // This fixes an issue for core pack components that utilize the Layer component, when in a legacy cookbook page.
  const scale = currentScale !== DefaultEnvironment.scale ? currentScale : undefined;

  const interpolations = mergeInterpolations<ThemeProps>([...Object.values(themeInterpolations)]);
  const { class: classes } = interpolations({ colorScheme, scale });
  return classes;
}
